module.exports = __webpack_public_path__ + "img/tickets.3a688db2.svg";